export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-foreground-950 text-foreground-50/80">
      <div className="h-px w-full bg-gradient-to-r from-primary-500/0 via-accent-500/60 to-primary-500/0" aria-hidden="true"></div>
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/d1b6ec71613fd44f076bb20c8764731b.png"
                alt="Guma Caffe Lounge Bar Zamušani — logotip"
                title="Guma Caffe Lounge Bar Zamušani — domači lokal v Gorišnici"
                className="h-11 w-auto object-contain flex-shrink-0"
              />
              <span className="font-heading text-lg font-bold text-foreground-50 tracking-tight">
                Guma Bar
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              Zmagovalec izbora Naj kava po izboru bralcev Ptujinfo 2024. Domač lokal s prijazno postrežbo v srcu Zamušanov.
            </p>
            {/* Award Badge Footer */}
            <div className="mt-4 inline-flex items-center gap-2 bg-accent-600/30 text-accent-300 px-3 py-1.5 rounded-full text-xs font-medium">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-trophy-line"></i>
              </div>
              Naj kava Ptujinfo 2024
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">
              Hitre povezave
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'O nas', id: 'o-nas' },
                { label: 'Ponudba', id: 'ponudba' },
                { label: 'Doživetje', id: 'dozivetje' },
                { label: 'Delovni čas', id: 'delovni-cas' },
                { label: 'Galerija', id: 'galerija' },
                { label: 'Kontakt', id: 'kontakt' },
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">
              Odpiralni čas
            </h4>
            <ul className="space-y-2">
              <li className="flex justify-between text-sm">
                <span className="text-foreground-300">Pon – Čet</span>
                <span className="text-foreground-200 whitespace-nowrap ml-4">06:30 – 23:00</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-foreground-300">Pet – Sob</span>
                <span className="text-accent-300 whitespace-nowrap ml-4">07:00 – 03:00</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-foreground-300">Nedelja</span>
                <span className="text-foreground-200 whitespace-nowrap ml-4">09:00 – 22:00</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">
              Kontakt
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-primary-400 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-300">Zamušani 2, 2272 Gorišnica</span>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-primary-400 text-sm"></i>
                </div>
                <div className="flex flex-col">
                  <a href="tel:051240383" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">051 240 383</a>
                </div>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-facebook-circle-fill text-primary-400 text-sm"></i>
                </div>
                <a
                  href="https://www.facebook.com/GumaBarZamusani"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  Guma Caffe Lounge Bar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Guma Bar Zamušani. Vse pravice pridržane.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-xs text-foreground-500">
              Zmagovalec — <strong className="text-accent-400">Naj kava Ptujinfo 2024</strong>
            </p>
            <a
              href="https://www.facebook.com/GumaBarZamusani"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook — Guma Caffe Lounge Bar"
              title="Guma Caffe Lounge Bar na Facebooku"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-foreground-50 hover:bg-secondary-600 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}